/**
 * IB URL pathnames allowed when userDetails.isRestrictedHierarchy is true.
 * Align with Sidebar.jsx filteredSidebarData (Dashboard + IB Wallet only).
 */
export const IB_RESTRICTED_HIERARCHY_ALLOWED_PATHS = ['/ib', '/ib/dashboard', '/ib/withdraw'];

/** Whether `url` (may include query) targets an IB route allowed when hierarchy is restricted. */
export const isIbRestrictedHierarchyAllowedUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  const path = url.split('?')[0].replace(/\/+$/, '') || '/';
  return IB_RESTRICTED_HIERARCHY_ALLOWED_PATHS.includes(path);
};
